// EE TODO: remove eslint-disable comment
/* eslint-disable */
import React from "react";
import moment from "moment-timezone";

import { getLillyCopaySignatureFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../../header";
import useBaseEEConfiguration from "../../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../../utils/updateFormData";
import renderReactFromJson from "../../../utils/renderReactFromJson";
import formJson from "./form/LillyCopaySignatureFormJson.json";
import { CompleteFormButton } from "../../../CompleteFormButton";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../../constants";
import { SignerTypes } from "../../../../../../constant/ESign";
import { DATE_FORMAT, dateFormatter } from "../../../../../../utils/date";

export const useLillyCopaySignatureConfiguration = () => {
  const vendorName = "lilly";
  const eePlanType = "copay_signature";
  const rootPath = "application_form_editor.lilly.copay_signature"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson });

  const lillySpecificConfig = {
    activeFormSection: "",
    getFormInitialValues: ({ applicationForm }) =>
      getLillyCopaySignatureFormInitialValues({ applicationForm, formJson }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    saveButton: (props) => (
      <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_lilly_copay_signature_save_form"} {...props} />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.COMPLETE_FORM,

    getSignatureWidgetSettingsBySignerType: (signerType) => {
      const signatureSettings = {
        [SignerTypes.PATIENT]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.patient",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        }
      };
      return signatureSettings[signerType];
    },
    getEnrollResultData: ({ application, t }) => ({
      bin: application.bin,
      pcn: application.pcn,
      group: application.group,
      member_id: application.memberId,
      expiration_date: application.effectiveIndefinitely
        ? t("patientApplications.valid_indefinitely")
        : dateFormatter(application.validThrough) || "--"
    }),
    getAdditionalResultCardInformation: false,
    getApprovedResultDescription: () => <></>,

    successMessage: (t, submittedDate, shouldAutoSubmit) =>
      t(
        !shouldAutoSubmit
          ? "patientApplications.enroll.application_form_submission.submit_completed_novartis"
          : "patientApplications.enroll.application_form_submission.auto_submit_succeeded",
        {
          submitDate: moment(submittedDate).format(DATE_FORMAT)
        }
      ),
    noCardResultText: (t) => t("patientApplications.enroll.enroll_result.lilly_support_enrollment_message"),
    shouldShowPdfInSecondStep: true
  };

  return {
    ...baseConfig,
    ...lillySpecificConfig
  };
};

export default useLillyCopaySignatureConfiguration;
